import * as $ from "jquery";
import {
    clearControlState,
    loadControlState,
    saveControlState,
} from "./formtools";
import { ISelectItem, populateMenu } from "./utility";

interface ScheduleMap {
    readonly [index: string]: Array<ISelectItem>;
}

const KEYREGION = "classroomstatefilter";
const KEYTESTDATE = "classroomdatefilter";
const REGIONTEXAS = "texas";

export class LsatClassroomScheduleFilter {
    $regions: JQuery;
    $testdates: JQuery;
    schedule: ScheduleMap;

    constructor(
        $regions: JQuery,
        $testdates: JQuery,
        schedule: ScheduleMap,
        selectedRegion?: string,
    ) {
        const self = this;
        this.$regions = $regions;
        this.$testdates = $testdates;
        this.schedule = schedule;

        if (selectedRegion) {
            $regions.val(selectedRegion);
            saveControlState($regions, KEYREGION);
            clearControlState(KEYTESTDATE);
        } else {
            loadControlState($regions, KEYREGION);
        }

        this.$regions.on("change", function () {
            const region = self.getSelectedRegion();
            //console.log("Selected state: " + region);
            if (region !== REGIONTEXAS) {
                saveControlState($regions, KEYREGION);
            } else {
                clearControlState(KEYREGION);
            }
            self.applyFilterRegion(false);
        });

        this.$testdates.on("change", function () {
            //console.log("Selected test date: " + self.getSelectedTestDate())
            saveControlState($testdates, KEYTESTDATE);
            self.applyFilter();
        });

        self.applyFilterRegion(true);
    }

    private applyFilterRegion(isFirst: boolean) {
        const region = this.getSelectedRegion();
        if (region && region === REGIONTEXAS) {
            if (!isFirst) {
                // only redirect on dd change, not when page appears
                location.href = "/LsatPrep/Texas";
                return;
            } else {
                // otherwise reset the dropdown
                $(".term").show();
                (<HTMLSelectElement> this.$regions[0]).selectedIndex = 0;
            }
        }

        const oldtestdate = this.getSelectedTestDate();
        this.populateTestDates(oldtestdate);

        if (isFirst) {
            // first time we load, attempt to restore the test date from session
            loadControlState(this.$testdates, KEYTESTDATE);
        } else {
            // otherwise let's clear the session state until something is selected
            clearControlState(KEYTESTDATE);
        }
        this.applyFilter();
    }

    private getSelectedRegion(): string {
        return <string> this.$regions.val();
    }

    private getSelectedTestDate(): string {
        return <string> this.$testdates.val();
    }

    private populateTestDates(selectedtestdate: string) {
        const region = this.getSelectedRegion();

        const testdates = region ? this.schedule[region] : this.schedule["all"];
        populateMenu(this.$testdates, testdates, "All", selectedtestdate);
    }

    private applyFilter() {
        const region = this.getSelectedRegion();
        const testdate = this.getSelectedTestDate();
        if (region) {
            if (testdate) {
                // filter region & test date
                $(".term").hide();
                $(".termregion-" + region + ".termdate-" + testdate).show();
                //console.log("Filter: region=" + region + " & testdate=" + testdate);
            } else {
                // filter region only
                $(".term").hide();
                $(".termregion-" + region).show();
                //console.log("Filter: region=" + region);
            }
        } else {
            if (testdate) {
                // filter test date only
                $(".term").hide();
                $(".termdate-" + testdate).show();
                //console.log("Filter: testdate=" + testdate);
            } else {
                //filter nothing
                $(".term").show();
                //console.log("Filter: ALL");
            }
        }
    }
}
